module.exports = __webpack_public_path__ + "img/badge_refazi_piattapasto.97cef237.jpg";